module.exports = __webpack_public_path__ + "static/media/star-preto.07b6f590.jpg";